import { hasSession, markSignedIn } from '../auth/account.js';
import { exportData, importData } from '../core/backup.js';
import { db, dbPut, tx } from '../core/db.js';
import { scopedCards } from '../core/load.js';
import { state } from '../core/state.js';
import { $, $$, esc, populateVoicePicker, speak, speakCurrent, ttsOK } from '../core/text.js';
import { wireBattlePreview } from '../game/battle.js';
import { G } from '../game/items.js';
import { advUpdateNav } from '../game/ui.js';
import { exportCardsAs, smartImportModal } from '../io/transfer.js';
import { deferredInstall, promptInstall } from './pwa.js';
import { renderStreak } from '../progress/streak.js';
import { renderCurrency, saveProgress } from '../progress/xp.js';
import { cloudDeleteAccount, cloudRedeemInvite, cloudSetReminders } from '../social/api.js';
import { comSetTab, publishModal, renderCommunity } from '../social/community.js';
import { saveUsername, scheduleFriendSearch } from '../social/friends.js';
import { renderLeaderboard } from '../social/profile.js';
import { cardModal } from '../study/editor.js';
import { battleSetup, checkWrite, flip, quizPick, rate, showCard, startSession, undoRate } from '../study/learn.js';
import { bulkAddModal } from '../ui/modal.js';
import { addCourseMenu } from '../ui/sidebar.js';
import { SFX, pushPop, toast } from '../ui/toast.js';
import { refresh, setView } from '../ui/views.js';
import { renderCalendar } from '../views/calendar.js';
import { cardManagerModal, collectionCards, renderCollections } from '../views/dashboard.js';
import { examModal } from '../views/exams.js';
import { dsgvoExport, setDark } from '../views/settings.js';
import { renderCards } from '../views/stats.js';

/* ══════════ Wiring ══════════ */
export function wire() {
  $('#btn-new-course').onclick = (e) => { e.stopPropagation(); addCourseMenu(e.currentTarget); };
  $('#btn-new-card').onclick = () => cardModal(null);
  $('#btn-bulk-add').onclick = bulkAddModal;
  $('#btn-exam').onclick = examModal;
  $('#buddy-box').onclick = () => setView('achievements');
  $$('.nav-link, .tab').forEach((el) => { el.onclick = () => setView(el.dataset.view); });
  $('#show-archived').onchange = (e) => { state.showArchived = e.target.checked; refresh(); };

  const chipGroup = (sel, cb) => $$(sel + ' .chip').forEach((el) => {
    el.onclick = () => { $$(sel + ' .chip').forEach((c) => c.classList.remove('active')); el.classList.add('active'); cb(el); };
  });
  chipGroup('#mode-chips', (el) => { state.mode = el.dataset.mode; });
  chipGroup('#studymode-chips', (el) => { state.studyMode = el.dataset.studymode; });
  chipGroup('#focus-chips', (el) => { state.focus = el.dataset.focus; });
  chipGroup('#filter-chips', (el) => { state.filter = el.dataset.filter; renderCards(); });
  chipGroup('#size-chips', (el) => {
    const custom = $('#size-custom');
    if (el.dataset.size === 'custom') { custom.classList.remove('hidden'); custom.focus(); state.size = +custom.value || 10; }
    else { custom.classList.add('hidden'); state.size = +el.dataset.size; }
  });
  $('#size-custom').oninput = (e) => { state.size = Math.max(1, +e.target.value || 1); };
  $('#card-search').oninput = (e) => { state.search = e.target.value.trim(); renderCards(); };

  $('#btn-coll-close').onclick = () => { state.coll = null; renderCollections(); };
  $('#btn-coll-learn').onclick = () => startSession(collectionCards(state.coll));

  $('#cal-prev').onclick = () => { state.calMonth = new Date(state.calMonth.getFullYear(), state.calMonth.getMonth() - 1, 1); renderCalendar(); };
  $('#cal-next').onclick = () => { state.calMonth = new Date(state.calMonth.getFullYear(), state.calMonth.getMonth() + 1, 1); renderCalendar(); };

  $('#btn-start').onclick = () => startSession();

  // ── Dashboard-Steuerung (neues Design) ──
  const segGroup = (sel, cb) => $$(sel + ' .v2-segbtn').forEach((el) => {
    el.onclick = () => { $$(sel + ' .v2-segbtn').forEach((x) => x.classList.remove('active')); el.classList.add('active'); cb(el); };
  });
  segGroup('#v2-studymode', (el) => { state.studyMode = el.dataset.studymode; });
  segGroup('#v2-mode', (el) => { state.mode = el.dataset.mode; });
  segGroup('#v2-focus', (el) => { state.focus = el.dataset.focus; });
  segGroup('#v2-size', (el) => { state.size = +el.dataset.size; });
  $('#v2-start').onclick = () => startSession();
  // Karten-Box auf der Übersicht (Karten-Reiter ist jetzt ein Popup)
  const dn = $('#dash-new-card'); if (dn) dn.onclick = () => cardModal(null);
  const db = $('#dash-bulk'); if (db) db.onclick = () => bulkAddModal();
  const di = $('#dash-import'); if (di) di.onclick = () => smartImportModal();
  const dm = $('#dash-manage'); if (dm) dm.onclick = () => cardManagerModal();
  $('#v2-nextexam').onclick = () => setView('calendar');
  $('#v2-duetoday').onclick = () => startSession();

  $('#btn-quit').onclick = () => { const b = state.session?.battle; state.session = null; battleSetup(false); setView(b ? 'adventure' : 'dashboard'); };
  const bx = $('#battle-exit'); if (bx) bx.onclick = () => { state.session = null; battleSetup(false); setView('adventure'); };
  wireBattlePreview();
  $('#btn-again').onclick = () => {
    const wasBattle = state.session?.battle;
    if (wasBattle) { const pool = scopedCards(); startSession(pool.length ? pool : state.cards, true); }
    else startSession();
  };
  $('#btn-back-dash').onclick = () => { const b = state.session?.battle; state.session = null; battleSetup(false); setView(b ? 'dashboard' : 'dashboard'); };
  const bu = $('#btn-upgrades'); if (bu) bu.onclick = () => { state.session = null; battleSetup(false); setView('adventure'); };
  $$('[data-rate]').forEach((el) => { el.onclick = () => rate(el.dataset.rate); });

  let clickTimer;
  $('#flashcard').onclick = () => { clearTimeout(clickTimer); clickTimer = setTimeout(() => flip(), 220); };
  $('#flashcard').ondblclick = () => { clearTimeout(clickTimer); flip('back'); };

  $('#btn-fav').onclick = async () => { const c = state.session.queue[state.session.i]; c.fav = !c.fav; await dbPut('cards', c); $('#btn-fav').classList.toggle('on', c.fav); $('#btn-fav').textContent = c.fav ? '★' : '☆'; toast(c.fav ? 'Favorit ★' : 'Favorit entfernt'); };
  $('#btn-later').onclick = async () => { const c = state.session.queue[state.session.i]; c.later = !c.later; await dbPut('cards', c); $('#btn-later').classList.toggle('on', c.later); toast(c.later ? 'Für später vorgemerkt ⏰' : 'Vormerkung entfernt'); };
  $('#btn-hint').onclick = toggleHint;
  $('#btn-tts').onclick = speakCurrent;
  $('#btn-edit').onclick = () => {
    const c = state.session.queue[state.session.i];
    cardModal(c, (rec) => { state.session.queue[state.session.i] = rec; showCard(); });
  };
  $('#btn-undo').onclick = () => undoRate();
  // Schreiben-Modus
  $('#write-check').onclick = checkWrite;
  $('#write-input').onkeydown = (e) => { if (e.key === 'Enter') { e.preventDefault(); checkWrite(); } };

  document.addEventListener('keydown', (e) => {
    // Zurücknehmen geht auch auf dem Rundenabschluss-Bildschirm
    if (state.view === 'study' && (e.key === 'u' || e.key === 'U')
        && !['INPUT', 'TEXTAREA', 'SELECT'].includes(e.target.tagName)
        && $('#modal').classList.contains('hidden')) { e.preventDefault(); undoRate(); return; }
    if (state.view !== 'study' || !$('#summary').classList.contains('hidden')) return;
    if (!$('#modal').classList.contains('hidden')) return;
    const s = state.session;
    const isField = ['INPUT', 'TEXTAREA', 'SELECT'].includes(e.target.tagName);
    // Quiz: Ziffern wählen Antwort (vor dem Aufdecken)
    if (s && s.curMode === 'quiz' && !s.answered && !isField && ['1', '2', '3', '4'].includes(e.key)) {
      const i = +e.key - 1; if (s.quizOpts && i < s.quizOpts.length) quizPick(i); return;
    }
    // Nach dem Aufdecken (oder klassisch umgedreht): 1–4 = bewerten
    const revealed = s && (s.answered || (s.curMode === 'flip' && $('#flip-inner').classList.contains('flipped')));
    if (revealed && !isField && ['1', '2', '3', '4'].includes(e.key)) { rate(['again', 'hard', 'good', 'easy'][+e.key - 1]); return; }
    if (isField) return;   // im Schreibfeld sonst nichts abfangen
    if (e.code === 'Space') { e.preventDefault(); flip(); return; }
    if (e.key === 'h') return toggleHint();
    if (e.key === 'v') return speakCurrent();
    if (e.key === 'f') return $('#btn-fav').click();
    if (e.key === 's') return $('#btn-later').click();
    if (e.key === 'e') return $('#btn-edit').click();
  });

  // Einstellungen
  $('#weekly-goal').value = state.goals.weekly;
  $('#btn-save-goal').onclick = async () => {
    state.goals.weekly = Math.max(1, +$('#weekly-goal').value || 100);
    await dbPut('meta', { key: 'goals', value: state.goals });
    toast('Wochenziel gespeichert ✦'); renderStreak();
  };
  $('#opt-sound').checked = localStorage.getItem('snd') !== '0';
  $('#opt-sound').onchange = (e) => { localStorage.setItem('snd', e.target.checked ? '1' : '0'); if (e.target.checked) SFX.good(); };
  $('#opt-scanlines').checked = localStorage.getItem('crt') === '1';
  $('#opt-scanlines').onchange = (e) => { localStorage.setItem('crt', e.target.checked ? '1' : '0'); document.body.classList.toggle('crt', e.target.checked); };
  $('#opt-dark').checked = document.body.classList.contains('dark');
  $('#opt-dark').onchange = (e) => setDark(e.target.checked);
  // Vorlese-Stimme
  populateVoicePicker();
  if (ttsOK() && !speechSynthesis.onvoiceschanged) speechSynthesis.onvoiceschanged = populateVoicePicker;
  const vsel = $('#opt-voice');
  if (vsel) vsel.onchange = (e) => { localStorage.setItem('ttsVoice', e.target.value); speak('Hallo, so klinge ich beim Vorlesen.'); };
  const vtest = $('#opt-voice-test');
  if (vtest) vtest.onclick = () => speak('Hallo, so klinge ich beim Vorlesen.');
  // Wöchentliche Erinnerung (Opt-out, im Cloud-Konto gespeichert)
  $('#opt-reminders').checked = state.progress.remindersOff !== true;
  $('#opt-reminders').onchange = async (e) => {
    state.progress.remindersOff = !e.target.checked;
    await saveProgress();
    if (hasSession()) { try { await cloudSetReminders(!state.progress.remindersOff); } catch (err) { /* offline: kommt beim nächsten Sync */ } }
    $('#reminder-status').textContent = e.target.checked ? 'Erinnerungen an ✓' : 'Erinnerungen aus.';
    setTimeout(() => { $('#reminder-status').textContent = ''; }, 2500);
  };
  $('#btn-dsgvo-export').onclick = dsgvoExport;
  // Wissensabenteuer an/aus
  const advOpt = $('#opt-adventure');
  if (advOpt) {
    advOpt.checked = G().on;
    advOpt.onchange = async (e) => {
      G().on = e.target.checked; await saveProgress(); advUpdateNav();
      if (!e.target.checked && state.view === 'adventure') setView('dashboard');
      toast(e.target.checked ? 'Wissensabenteuer aktiviert 🐱⚔️' : 'Wissensabenteuer ausgeschaltet');
    };
  }
  const instBtn = $('#btn-install'); if (instBtn) { instBtn.onclick = promptInstall; if (deferredInstall) instBtn.classList.remove('hidden'); }
  // Profil wird direkt am Profil bearbeitet (Inline-Stift), siehe wireProfileEditors().

  $('#btn-export').onclick = () => exportData(false);
  $('#btn-export-scope').onclick = () => exportData(true);
  $('#btn-import').onclick = () => $('#import-file').click();
  $('#import-file').onchange = async (e) => { if (e.target.files[0]) await importData(e.target.files[0]); e.target.value = ''; };

  // ── Import aus anderen Apps + Export als CSV/Anki ──
  $('#btn-smart-import').onclick = smartImportModal;
  $('#btn-export-csv').onclick = () => exportCardsAs('csv');
  $('#btn-export-anki').onclick = () => exportCardsAs('anki');

  // ── Community ──
  $('#com-publish').onclick = publishModal;
  $$('#view-community .com-tab').forEach((b) => b.onclick = () => comSetTab(b.dataset.com));
  let comTimer = null;
  $('#com-search').oninput = () => { clearTimeout(comTimer); comTimer = setTimeout(renderCommunity, 350); };
  $('#com-sort').onchange = renderCommunity;

  // ── Freunde ──
  // Knopf mitgeben, damit er während des Speicherns seinen Ladezustand zeigt.
  $('#fr-username-save').onclick = (e) => saveUsername(e.currentTarget);
  $('#fr-search').oninput = () => scheduleFriendSearch();
  const redeemBtn = $('#fr-redeem-btn');
  if (redeemBtn) redeemBtn.onclick = async () => {
    const code = ($('#fr-redeem').value || '').trim().toUpperCase();
    const st = $('#fr-invite-status');
    if (!code) { st.textContent = 'Bitte einen Code eingeben.'; return; }
    try {
      const r = await cloudRedeemInvite(code);
      state.progress.gems += (r.gems || 0); await saveProgress(); renderCurrency();
      st.textContent = `Code eingelöst – +${r.gems} 💎! 🎉`;
      $('#fr-redeem').value = '';
      pushPop({ img: 'assets/icon_gem.png', eyebrow: 'Code eingelöst', name: 'Willkommensgeschenk', reward: `+${r.gems} 💎` });
    } catch (e) { st.textContent = e.message || 'Code konnte nicht eingelöst werden.'; }
  };

  // ── Bestenliste: Sortierung ──
  $$('#view-profile .lb-tab').forEach((b) => b.onclick = () => { state.lbSort = b.dataset.lb; renderLeaderboard(); });
  $('#btn-reset').onclick = async () => {
    if (!confirm('Wirklich ALLES löschen? Kein Zurück.\n\nTipp: Mach vorher eine Sicherung.')) return;
    for (const s of ['cards', 'decks', 'courses', 'log']) await new Promise((r) => { tx(s, 'readwrite').clear().onsuccess = r; });
    state.cards = []; state.decks = []; state.courses = []; state.log = [];
    state.selCourse = null; state.selDecks.clear(); state.openCourses.clear();
    toast('Alles gelöscht'); setView('dashboard');
  };
  const del = $('#btn-delete-account'); if (del) del.onclick = deleteAccount;
}
export async function deleteAccount() {
  const sure = prompt('Dein Konto und ALLE zugehörigen Daten (Lernstand, veröffentlichte Decks, Freunde, Bewertungen, Bestenlisten-Eintrag) werden UNWIDERRUFLICH gelöscht.\n\nTippe LÖSCHEN (in Großbuchstaben), um fortzufahren:');
  if ((sure || '').trim().toUpperCase() !== 'LÖSCHEN') { toast('Abgebrochen – nichts gelöscht.'); return; }
  /* Löschen ist endgültig – wer ein Passwort hat, gibt es hier noch einmal
     ein. Eine gekaperte Sitzung soll damit nicht alles vernichten können. */
  let pass = '';
  if (state.me?.hasPassword) {
    pass = prompt('Zur Sicherheit noch einmal dein Passwort:') || '';
    if (!pass) { toast('Abgebrochen – nichts gelöscht.'); return; }
  }
  try {
    await cloudDeleteAccount(pass);
    markSignedIn(false);
    for (const s of ['cards', 'decks', 'courses', 'log']) await new Promise((r) => { tx(s, 'readwrite').clear().onsuccess = r; });
    toast('Konto & alle Daten gelöscht. Auf Wiedersehen 🌱');
    setTimeout(() => location.reload(), 1400);
  } catch (e) { toast('Fehler beim Löschen: ' + e.message); }
}
export function toggleHint() {
  const card = state.session?.queue[state.session.i];
  if (!card?.hint) { toast('Für diese Karte gibt es keinen Hinweis'); return; }
  $('#hint-box').innerHTML = `<img class="hint-cat" src="assets/cat_idea.png" alt=""><span><b>Hinweis:</b> ${esc(card.hint)}</span>`;
  $('#hint-box').classList.toggle('hidden');
}

